const storeTravelChargeTypes = {
    PerKm: "Kilometers Only",
    PerHour: "Time Only",
    FlatRate: "Flat Rate",
    KmAndHour: "Time and Kilometers"
};

export default storeTravelChargeTypes;
